module.exports = __webpack_public_path__ + "img/loginD.ee20cc16.png";